import { render, staticRenderFns } from "./ReviewCard.vue?vue&type=template&id=bd165a58&scoped=true&"
import script from "./ReviewCard.vue?vue&type=script&lang=js&"
export * from "./ReviewCard.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCard.vue?vue&type=style&index=0&id=bd165a58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd165a58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd165a58')) {
      api.createRecord('bd165a58', component.options)
    } else {
      api.reload('bd165a58', component.options)
    }
    module.hot.accept("./ReviewCard.vue?vue&type=template&id=bd165a58&scoped=true&", function () {
      api.rerender('bd165a58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/ReviewCard.vue"
export default component.exports